//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import * as merchant from '@/api/merchant';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'c_merchantName',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    number: {
      type: null
    }
  },
  data: function data() {
    return {
      merProps: {
        value: 'id',
        label: 'name',
        children: 'merchantList',
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true
      },
      merchantList: [],
      defaults: {},
      configData: {},
      timeStamp: '',
      merIds: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (checkPermi(['platform:merchant:page:list'])) this.getMerList();
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
      _this.merIds = _this.configData.activeValue;
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
        this.merIds = this.configData.activeValue;
      },
      deep: true
    },
    number: function number(nVal) {
      this.timeStamp = nVal;
    }
  },
  methods: {
    checkPermi: checkPermi,
    // 列表
    getMerList: function getMerList() {
      var _this2 = this;
      merchant.merCategoryListApi().then(function (res) {
        _this2.merchantList = res;
      });
    },
    onChangeMerId: function onChangeMerId(e) {
      this.configData.activeValue = e;
      this.$emit('getConfig', {
        name: 'merchantName',
        values: e
      });
    }
  }
};